import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import https, { fetchPost } from '../https.js';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import { Message } from 'element-ui';
import custom from './components/page/common/custom.js';
import accvoucher from './components/page/common/accvoucher.js';
import qs from 'qs';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.baseURL = axios.defaults.baseURL; //  后台请求地址
Vue.prototype.ofdReaderPath = "http://www.vatunion.com:14381/";   //  ofd path
//Vue.prototype.ofdReaderPath = "http://localhost:8080/";
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(https);
Vue.use(ElementUI, {
    size: 'small'
});
Vue.use(custom);
Vue.use(accvoucher);    //  记账凭证版式
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

Vue.prototype.$qs = qs;

//  单个文件上传大小限制：50M（单位M）
Vue.prototype.uploadFileLimitSize = 50;
//  菜单标题 list
Vue.prototype.menuTitleList = ["archivesCollection", "archivesVerify", "archivesArrangement", "sysConfig"];

//  分页对象
Vue.prototype.pageobj = {
    count: 0,
    limit: 10,
    page: 1,
    limits: [10, 20, 50, 100]
}

//  status select data
Vue.prototype.statusData = [
    { value: '0', label: '正常' },
    { value: '1', label: '停用' }
]

//  user type select data
Vue.prototype.userTypeData = [
    { value: '1', label: '集团管理员' },
    { value: '2', label: '集团用户' }
]

//  user type constant
Vue.prototype.userTypeCon = {
    USER_TYPE_SUPER : '0',  //  超管
    USER_TYPE_GROUP: '1',   //  集团管理员
    USER_TYPE_ORDINARY: '2' //  集团用户
}

//  role type constants
Vue.prototype.roleTypeCon = {
    ROLE_TYPE_GROUP: '1',   //  集团管理员
    ROLE_TYPE_ORDINARY: '2' //  集团用户
}

//  原始凭证 - 凭证类型 list
Vue.prototype.originalvoucherTypeList = [
    { title: '电子专票', name: 'archives-dzzp', code: '1' },
    { title: '电子普票', name: 'archives-dzpp', code: '2' },
    { title: '纸质专票', name: 'archives-zzzp', code: '3' },
    { title: '纸质普票', name: 'archives-zzpp', code: '4' },
    { title: '定额发票', name: 'archives-defp', code: '5' },
    { title: '过路费发票', name: 'archives-glffp', code: '6' },
    { title: '出租车发票', name: 'archives-czcfp', code: '7' },
    { title: '火车票', name: 'archives-hcp', code: '8' },
    { title: '行程单', name: 'archives-hk', code: '9' },
    { title: '机动车发票', name: 'archives-jdcfp', code: '10' },
    {title: '海关缴款书', name: 'archives-payment', code: '11'},
    {title: '银行回单', name: 'archives-bank-receipt', code: '12'},
    {title: '其他', name: 'archives-otherShow', code: '13'},
    {title: '全电电专', name: 'archives-all-electric-evat', code: '14'},
    {title: '全电电普', name: 'archives-all-electric-envat', code: '15'},
    {title: '全电纸普', name: 'archives-all-electric-vat', code: '16'},
    {title: '全电纸普', name: 'archives-all-electric-nvat', code: '17'}
];

//  记账凭证 list
Vue.prototype.accountingVoucherTypeList = [
    { title: '记账凭证', name: 'archives-jz', code: '0' },
];

//  文件状态 list
Vue.prototype.fileStatusList = [
    { title: '已上传', name: 'archives-ysc', code: '0' },
    { title: '验证通过', name: 'archives-yztg', code: '1' },
    { title: '验证拒绝', name: 'archives-yzjj', code: '2' },
    { title: '分组中', name: 'archives-fzz', code: '3' },
    { title: '已分组', name: 'archives-yfz', code: '4' },
    { title: '成册中', name: 'archives-ccz', code: '5' },
    { title: '已成册', name: 'archives-ycc', code: '6' }
];

//  审核状态 list
Vue.prototype.auditStatusList = [
    { title: '已上传', name: 'archives-ysc', code: '0' },
    { title: '验证通过', name: 'archives-yztg', code: '1' },
    { title: '验证拒绝', name: 'archives-yzjj', code: '2' }
]

//  分组状态 list
Vue.prototype.archiveGroupStatusList = [
    { title: '分组中', name: 'archives-fzz', code: '0' },
    { title: '已分组', name: 'archives-yfz', code: '1' },
    { title: '成册中', name: 'archives-ccz', code: '2' },
    { title: '已成册', name: 'archives-ycc', code: '3' }
];

//  成册状态 list
Vue.prototype.archiveBookStatusList = [
    { title: '成册中', name: 'archives-ccz', code: '0' },
    { title: '已成册', name: 'archives-ycc', code: '1' }
];

//  手工成册 凭证名称 list
Vue.prototype.archiveVolumeVoucherNameList = [
    { value: '1', label: '记账凭证' },
    { value: '2', label: '其他凭证' }
]

//  文件密级 list
Vue.prototype.secretLevelList = [
    { value: '1', label: '1级 - 绝密' },
    { value: '2', label: '2级 - 机密' },
    { value: '3', label: '3级 - 秘密' },
    { value: '4', label: '4级 - 一般' },
    { value: '5', label: '5级 - 公开' }
];

//  文件类型
Vue.prototype.fileTypeList = [
    { label: '会计凭证', value: '1' }, 
    { label: '会计账簿', value: '2' }, 
    { label: '会计报告', value: '3' }, 
    { label: '其他会计资料', value: '4' }, 
    { label: '其他', value: '5' }
];

//  format 状态：0 - 正常 1 - 停用
Vue.prototype.formatStatus = function (row, column, cellValue, index) {
    if (cellValue == '0') {
        return '正常';
    } else if (cellValue == '1') {
        return '停用'
    } else {
        return '';
    }
}
//  format 导入方式：1 - 文件导入 2 - 接口导入
Vue.prototype.formatImportWay = function(row, column, cellValue, index) {	
    if (cellValue == '1') {
        return '文件导入';
    } else if (cellValue == '2') {
        return '接口导入';
    } else if(cellValue == '3'){
        return '共享文件夹读取';
    } else if(cellValue == '4'){
        return '邮件抓取';
    } else {
        return cellValue;
    }
},

//  format 时间：年-月-日
Vue.prototype.timestampFormatter = function (cellValue) {
    if (cellValue && cellValue != "*") {
        var date = new Date(cellValue);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        m = m < 10 ? '0' + m : m;
        d = d < 10 ? '0' + d : d;
        return y + '年' + m + '月' + d + '日';
    } else if(cellValue && cellValue == '*') {
        return cellValue;
    } else {
        return "";
    }
}


//  format 时间：年-月-日 时:分:秒
Vue.prototype.timestampSecondFormatter = function (cellValue) {
    if (cellValue && cellValue != "*") {
        var date = new Date(cellValue);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let hour = date.getHours();
        let mim = date.getMinutes();
        let scound = date.getSeconds();
        m = m < 10 ? '0' + m : m;
        d = d < 10 ? '0' + d : d;
        return y + '年' + m + '月' + d + '日 ' + hour+ '时'+mim+'分'+scound+'秒';
    } else if(cellValue && cellValue == '*') {
        return cellValue;
    } else {
        return "";
    }
}

//  format 金额： 千分位、保留两位效数
Vue.prototype.formatAmountSeparator = function(value) {
    if (value && value != "*") {
        if ((value + '').indexOf(',') != -1) {
            return value;
        } else {
            return (parseFloat(value).toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
        }
    } else if(value && value == "*") {
        return value;
    } else {
        return '';
    }
}

//  验证邮箱
Vue.prototype.checkEmail = (rule, value, callback) => {
    //  支持复杂邮箱
    const regEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
    if (regEmail.test(value) || !value) {
        //  合法的邮箱
        return callback()
    }
    callback(new Error('请输入有效的邮箱'));
}
//  验证手机号
Vue.prototype.checkMobile = (rule, value, callback) => {
    //  验证手机号的正则表达式
    const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    if (regMobile.test(value) || !value) {
        //  合法的手机号
        return callback()
    }
    callback(new Error('请输入有效的手机号'));
}

//  用户关联实体信息
Vue.prototype.getUserBeLongsCompanyList = async function () {
    let companyList = [];
    await fetchPost('/sys/main/getUserBeLongsCompanyList', '').then(res => {
        if (res.data.success) {
            companyList = res.data.obj;
        } else {
            Message.error(res.data.message);
        }
    }).catch(error => {
        Message.error(error);
    });
    return companyList;
}

//  用户已勾选实体信息
Vue.prototype.getUserCheckCompanyList = async function () {
    let companyList = [];
    await fetchPost('/sys/main/getUserCheckCompanyList', '').then(res => {
        if (res.data.success) {
            companyList = res.data.obj;
        } else {
            Message.error(res.data.message);
        }
    }).catch(error => {
        Message.error(error);
    });
    return companyList;
}

//  获取当前用户信息
Vue.prototype.getCurrentUserList = async function () {
    let currUserList = [];
    await fetchPost('/sys/main/getCurrentUserList', '').then(res => {
        if (res.data.success) {
            currUserList = res.data.obj;
        } else {
            Message.error(res.data.message);
        }
    }).catch(error => {
        Message.error(error);
    });
    return currUserList;
}

//  当前用户密级权限
Vue.prototype.getUserSecretLevel = async function () {
    let currUserSecretLevel = "";
    await fetchPost('/sys/admin/getCurrUserSecretLevel', '').then(res => {
        if (res.data.success) {
            currUserSecretLevel = res.data.obj;
        } else {
            Message.error(res.data.message);
        }
    }).catch(error => {
        Message.error(error);
    });
    return currUserSecretLevel;
}

// 原始凭证电票原文件状态
Vue.prototype.formatOriginInvoiceSourceType = function (row, column, cellValue, index) {
    if (cellValue == '0') {
        return '是';
    } else if (cellValue == '1') {
        return '否'
    } else if (cellValue == '2') {
        return '可疑'
    } else if (cellValue == '9999') {
        return '异常'
    } else {
        return '';
    }
}

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
